$(function() {
	var audio = require('./audio');
	var interaction = require('./interaction');

	audio.load(function() {
		interaction.loading(false);

		var experience = require('./create');

		interaction.play(function() {
			audio.play();
			experience.start();
		});

		interaction.pause(function() {
			audio.pause();
			experience.pause();
		});

		audio.progress_stream.onValue(interaction.progress);

		audio.finished(function() {
			experience.finished();
			interaction.finished();
		});
	});
});